interface IHippoMood {
  src: string;
  size: ISize;
}

interface ISize {
  width: number;
  height: number;
}
export const getRandomHippo = (arr: IHippoMood[]): IHippoMood => {
  const index = Math.floor(Math.random() * arr.length);
  return arr[index];
};
